/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import RoundedButton from '../buttons/Rounded';
import ArrowIcon from '../icons/Arrow';
import CircledPlusIcon from '../icons/CircledPlus';
import Louve from '../icons/Louve';
import Detector from '../partials/Detector';
import Grid from '../partials/Grid';
import IconLink from '../partials/IconLink';

import styles from '../../../styles/lists/loading-list.module.scss';

const propTypes = {
    loading: PropTypes.bool,
    initialLoading: PropTypes.bool,
    ended: PropTypes.bool,
    isGrid: PropTypes.bool,
    gridColumns: PropTypes.number,
    withAutoLoad: PropTypes.bool,
    withMore: PropTypes.bool,
    onClickMore: PropTypes.func,
    onClickEnd: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    loading: false,
    initialLoading: false,
    ended: false,
    isGrid: false,
    gridColumns: null,
    withMore: false,
    withAutoLoad: false,
    onClickMore: null,
    onClickEnd: null,
    className: null,
    children: null,
};

const LoadingList = ({
    loading,
    initialLoading,
    ended,
    isGrid,
    gridColumns,
    withMore,
    withAutoLoad,
    onClickMore,
    onClickEnd,
    className,
    children,
}) => {
    const clickNext = useCallback(() => {
        if (onClickMore !== null) {
            onClickMore();
        }
    }, [onClickMore]);

    const clickEnd = useCallback(() => {
        if (onClickEnd !== null) {
            onClickEnd();
        }
    }, [onClickEnd]);

    const child = isGrid ? <Grid columns={gridColumns}>{children}</Grid> : children;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isLoading]: loading,
                },
            ])}
        >
            {/* <Louve className={styles.load} loading /> */}
            {!initialLoading ? child : null}
            {withMore && !ended ? (
                <div className={styles.loadMore}>
                    {withAutoLoad ? <Detector onEnter={clickNext} /> : null}
                    <Louve className={styles.loadMoreLoadingIcon} loading />
                    <RoundedButton
                        className={styles.button}
                        onClick={clickNext}
                        icon={<CircledPlusIcon />}
                        iconPosition="right"
                    >
                        <FormattedMessage defaultMessage="View more" description="Button label" />
                    </RoundedButton>
                </div>
            ) : null}
            {withMore && ended ? (
                <div className={styles.end}>
                    <IconLink
                        className={styles.button}
                        onClick={clickEnd}
                        icon={<ArrowIcon direction="top" />}
                        iconPosition="right"
                        scrollTop
                        isDark
                    >
                        <FormattedMessage defaultMessage="Back to top" description="Button label" />
                    </IconLink>
                </div>
            ) : null}
        </div>
    );
};

LoadingList.propTypes = propTypes;
LoadingList.defaultProps = defaultProps;

export default LoadingList;
